export default __webpack_public_path__ + "static/media/jackpot.c639cd41.png";